// extracted by mini-css-extract-plugin
module.exports = {"root":"image-brand-card-module--root--1YmAT"};